export const toTitleCase = (str) =>
  str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  )

//data should include page and viewer
export const showDownloadBtnForTrialUser = (viewer, isPurchased, free) => {
  if (!viewer) {
    return false
  } else {
    return isPurchased || free || !viewer.isFreeTrial
  }
}

export const canViewProduct = (product) => {
  return (
    !!product &&
    product.files &&
    product.files.length &&
    (product.isSpecialAccess || product.isPurchased || product.free)
  )
}

export const filterObjectKeys = (allowed, original) => {
  return Object.keys(original)
    .filter((key) => allowed.includes(key))
    .reduce((obj, key) => {
      obj[key] = original[key]
      return obj
    }, {})
}
